const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const trimTrailingSlash = (value: string) => value.replace(/\/$/, '');

type RuntimeLocation = Pick<Location, 'hostname' | 'origin'>;

export const buildApiUrl = (
  path: string,
  baseUrl = process.env.REACT_APP_API_BASE_URL || '',
  runtimeLocation: RuntimeLocation | undefined = typeof window !== 'undefined' ? window.location : undefined,
): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const normalizedBaseUrl = trimTrailingSlash(baseUrl);

  if (!normalizedBaseUrl) {
    return normalizedPath;
  }

  if (runtimeLocation && process.env.NODE_ENV === 'development') {
    try {
      const apiUrl = new URL(normalizedBaseUrl);
      const appIsLocal = LOCAL_HOSTNAMES.has(runtimeLocation.hostname);
      const apiIsLocal = LOCAL_HOSTNAMES.has(apiUrl.hostname);

      if (appIsLocal && apiIsLocal && apiUrl.origin !== runtimeLocation.origin) {
        return normalizedPath;
      }
    } catch {
      return `${normalizedBaseUrl}${normalizedPath}`;
    }
  }

  return `${normalizedBaseUrl}${normalizedPath}`;
};
